import CONFIG from '../../config';

const actions = {
  v5Emandate(context, params) {
    context.commit('ADD_LOG', { request: 'v5Emandate' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('v5Emandate', params.uuid)}${params.bankName}`, {
          headers:
          {
            'x-phone-number': localStorage.getItem('phone'),
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'v5Emandate' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'v5Emandate' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  v6Emandate(context, params) {
    context.commit('ADD_LOG', { request: 'v6Emandate' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('v6Emandate', params.loanId)}`, {
          headers:
          {
            'x-phone-number': localStorage.getItem('phone'),
            Authorization: localStorage.getItem('token')
          }

        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'v6Emandate' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'v6Emandate' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  emandateRegister(context, params) {
    context.commit('ADD_LOG', { request: 'emandateRegister' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('emandateRegister', params.uuid), {
          headers:
          {
            'x-phone-number': localStorage.getItem('phone'),
            Authorization: localStorage.getItem('token')
          }

        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'emandateRegister' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'emandateRegister' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  }
};
export default actions;
